import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

const audio = {
  bgaudio: null,
  heliaudio: null,
  hintaudio: null,
  yayaudio: null,
  incorrectdropaudio: null,
  correctdropaudio: null,
  wrongdivideaudio: null,
  correctdivideaudio: null,
};
for (let i = 1; i <= 10; i++) audio['qa' + i] = null;
for (let i = 1; i <= 6; i++) audio['ta' + i] = null;

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio,
};

export const gameState = {
  score: 0,
  attempted: 0,
  questionNumber: 0,
  hints: 0,
  gameWin: false,
  value: 1,
};
